import React from "react";
import { Header } from "../../components/Header";
import "./styles.less";
import { CustomerDetailBanner } from "../../blocks/heigh-educate-banner";
import { CustomerConsult } from "../../blocks/common-customer-consult";
import { useTranslation } from "react-i18next";
import { CommonPageLink } from "../../blocks/common-page-link";
import { CustomerDetailIntro } from "../../blocks/customer-detail-intro";
import { Footer } from "../../components/FooterV2";
import { CustomerDetailChallenge } from "../../blocks/customer-detail-challenge";
import { CustomerDetailIdea } from "../../blocks/customer-detail-idea";
import { HomeTryOn } from "../../blocks/home-try-on";
import { Helmet } from "react-helmet";

export const HeighEducatePage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const challenges = [
    {
      title: t("customer.heigh-educate.challenge.item1.title"),
      description: t("customer.heigh-educate.challenge.item1.description"),
    },
    {
      title: t("customer.heigh-educate.challenge.item2.title"),
      description: t("customer.heigh-educate.challenge.item2.description"),
    },
    {
      title: t("customer.heigh-educate.challenge.item3.title"),
      description: t("customer.heigh-educate.challenge.item3.description"),
    },
    {
      title: t("customer.heigh-educate.challenge.item4.title"),
      description: t("customer.heigh-educate.challenge.item4.description"),
    },
  ];
  const ideas = [
    {
      title: t("customer.heigh-educate.ideas.item1.title"),
      descript: t("customer.heigh-educate.ideas.item1.subtitle"),
      icon: "authing-like",
    },
    {
      title: t("customer.heigh-educate.ideas.item2.title"),
      descript: t("customer.heigh-educate.ideas.item2.subtitle"),
      icon: "authing-insurance",
    },
    {
      title: t("customer.heigh-educate.ideas.item3.title"),
      descript: t("customer.heigh-educate.ideas.item3.subtitle"),
      icon: "authing-idcard",
    },
    {
      title: t("customer.heigh-educate.ideas.item4.title"),
      descript: t("customer.heigh-educate.ideas.item4.subtitle"),
      icon: "authing-deploymentunit",
    },
  ];
  return (
    <div className="hep-page">
      <Helmet>
        <title>
          高等教育出版社SSO单点登录案例，高等教育出版社统一身份认证案例
        </title>
      </Helmet>
      <Header mode="dark" defaltNav={true} />
      <CustomerDetailBanner
        title={t("customer.heigh-educate.banner.title")}
        subtitle={t("customer.heigh-educate.banner.subtitle")}
        theme="#034A9F"
        imgUrl={
          "//files.authing.co/authing-website/customer-detail-heigh-educate-tiny.png"
        }
        alt="高等教育出版社单点登录案例"
      />
      <CustomerDetailIntro
        imgUrl={t("customer.heigh-educate.intro.imgUrl")}
        alt="教育行业实现单点登录"
        content={
          <>
            <p>{t("customer.heigh-educate.intro.descript1")}</p>
            <p>{t("customer.heigh-educate.intro.descript2")}</p>
            <p>{t("customer.heigh-educate.intro.descript3")}</p>
          </>
        }
      />
      <CustomerDetailChallenge challenges={challenges} theme="#034A9F" />
      <CustomerDetailIdea ideas={ideas} theme="#034A9F" />
      <CommonPageLink pagesLink={pagesLink} />
      {/* <CustomerConsult /> */}
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
